var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 0C3.58886 0 0 3.58886 0 8.00002C0 12.4112 3.58886 16 8.00002 16C12.4112 16 16 12.4112 16 8.00002C16 3.58886 12.4111 0 8.00002 0ZM8.52039 12.7466C8.14032 12.81 7.38405 12.9682 7.00001 13C6.67493 13.027 6.36817 12.8409 6.18117 12.5738C5.99368 12.3067 5.94875 11.9649 6.06006 11.6582L7.57227 7.50003H6C5.99865 6.63357 6.64856 5.99649 7.47979 5.75199C7.87647 5.63527 8.61553 5.47556 8.99999 5.50004C9.23033 5.51469 9.63183 5.6592 9.81883 5.92632C10.0063 6.19341 10.0512 6.53521 9.93994 6.84185L8.42773 11H9.99952C9.99982 11.8655 9.37415 12.6043 8.52039 12.7466ZM8.99999 5.00002C8.44769 5.00002 7.99998 4.55225 7.99998 4.00001C7.99998 3.44771 8.44769 3 8.99999 3C9.5523 3 10 3.44771 10 4.00001C10 4.55228 9.55233 5.00002 8.99999 5.00002Z",
    fill: "white",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.b494af19c81f0781409e2b50a3b42d54.svg";
export { ForwardRef as ReactComponent };